import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

export const advP9BudgetCapped: FaireAdvertiserProfileEntity = {
  token: "adv_p9_budget_capped",
  type: "advertiserProfile",
  archetype: "budget-capped",
  displayName: "Wildflower & Co.",
  brandToken: "b_adv_p9_budget_capped",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 22,
  budget: {
    totalBudgetDollars: 4900,
    spendingMode: "MAXIMUM",
    nextRenewsAtDate: "2026-08-01",
    nextBillsAtDate: "2026-08-04",
  },
  overview: {
    numCustomersAcquired: 363,
    numReorderConversions: 196,
    numTotalConversions: 559,
    totalAdsSalesDollars: 164766,
    newCustomerAdsSalesDollars: 111681,
    reorderAdsSalesDollars: 53085,
    totalAdsSpendDollars: 24714,
    newCustomerAdsSpendDollars: 19481,
    reorderAdsSpendDollars: 5233,
    newCustomerBestEstimateFirstYearRoas: 5.73,
    reorderRoas: 10.14,
    combinedFirstYearRoas: 6.67,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 4000,
      maxRecommendedBudgetDollars: 6000,
    },
    reorder: {
      minRecommendedBudgetDollars: 900,
      maxRecommendedBudgetDollars: 1350,
    },
  },
  campaignTokens: [
    "camp_p9_budget_capped_new",
    "camp_p9_budget_capped_reorder",
  ],
  overviewPerformancePeriodTokens: [
    "perf_p9_budget_capped_ovw_202512",
    "perf_p9_budget_capped_ovw_202601",
    "perf_p9_budget_capped_ovw_202602",
    "perf_p9_budget_capped_ovw_202603",
    "perf_p9_budget_capped_ovw_202604",
    "perf_p9_budget_capped_ovw_202605",
    "perf_p9_budget_capped_ovw_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
